import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ThemeButton, useModalContext } from '../../../../ui'
import { dataToXLS, getFormattedTime } from '../../../../core/utils'
import { APPS_TABLE_COLUMNS, EXTRA_COLUMNS } from '../../constants'
import { useSupervisionContext } from '../../contexts'
import { useAppSupervisionCalls } from '../../hooks/supervision-calls.hook'
import { ExportNotEmptyDialog, ExportSomethingDialog } from '../dialogs'
import { supervisionDataPreparation } from '../../logics'

export const ExportToXLSBtn = () => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const { getAllSupervisionApps } = useAppSupervisionCalls()
  const [loading, setLoading] = useState(false)

  const {
    actions: { open },
  } = useModalContext()

  const {
    state: {
      tableSelection: selectedRows,
      search: { _num_x_pagina, _pagina, ...otherSearch },
      pagination: { total_solicitudes },
    },
  } = useSupervisionContext()
  const from = 'supervision'

  const mainExport = async (data) => {
    const fileName = `solicitudes_${getFormattedTime()}.xlsx`
    const columns = [...APPS_TABLE_COLUMNS, ...EXTRA_COLUMNS]
    await dataToXLS(data, columns, combos, intl, from, fileName)
  }

  const handleExportAll = async () => {
    if (!total_solicitudes) {
      open({
        Component: ExportNotEmptyDialog,
      })
      return
    }

    setLoading(true)
    try {
      const { data } = await getAllSupervisionApps({
        params: {
          ...otherSearch,
          _num_x_pagina: 0,
        },
        timeout: 0,
      })
      const preparedData = supervisionDataPreparation(data.tareas, { intl }, combos)
      await mainExport(preparedData)
    } catch (error) {
      console.error('Error al exportar todos los datos:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    if (!selectedRows?.length) {
      open({
        Component: ExportSomethingDialog,
      })
      return
    }

    setLoading(true)
    try {
      await mainExport(selectedRows)
    } catch (error) {
      console.error('Error al exportar la selección:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ThemeButton
        color="primary"
        variant="text"
        labelM="sm"
        fullWidth={true}
        disabled={!selectedRows.length || loading}
        loading={loading}
        onClick={handleExport}
        style={{ justifyContent: 'start' }}
      >
        {intl.formatMessage({ id: 'global.exportSelected' })} ({selectedRows.length})
      </ThemeButton>
      <ThemeButton
        color="primary"
        variant="text"
        labelM="sm"
        fullWidth={true}
        loading={loading}
        disabled={loading}
        onClick={handleExportAll}
        style={{ justifyContent: 'start' }}
      >
        {intl.formatMessage({ id: 'global.exportAll' })}
      </ThemeButton>
    </>
  )
}
